// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `cu-icon.styled-link-icon {
  color: #bec3c7 !important;
}
cu-icon.styled-link-icon svg {
  width: 12px !important;
  height: 12px !important;
}
`, "",{"version":3,"sources":["webpack://./app/styled-link-icon/styled-link-icon.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAAA;EAII,sBAAA;EACA,uBAAA;AADJ","sourcesContent":["@import (reference) \"../../../css/unison\";\n\ncu-icon.styled-link-icon {\n  color: @cu-gray-4 !important;\n\n  svg {\n    width: 12px !important;\n    height: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
